<template>
  <gj-modal

      :visible.sync="modalVisible"
      size="full-middle"
      :no-padding="true"
      @open="modalOpen"
      @cancel="cancel"
      @confirm="confirm"
      :contentStyle="{'height': '100%', display: 'flex', 'flex-direction': 'column'}"
  >
    <template #header>
      <span>添加产品</span>
    </template>
    <template #content>
      <app-base-main
          :table-shadow="false"
          :no-padding="true"
          parent-table
          style="padding: 10px 10px 0;">
        <template #filter-group>
          <app-filter-group
              :reset="false"
              @query="$gjNoticeQuery"
              @reset="$gjReset">
            <gj-select-input
                v-model="filter.keyword"
                :options="option.keyword"
                :width="['100px', '200px']"
                :matching.sync="matchType"
            ></gj-select-input>
            <gj-category-select
                v-model="filter.categoryId"
            ></gj-category-select>
          </app-filter-group>
        </template>
        <template #table>
          <gj-table
            ref="gjTable"
            name="addFbaShipmentProductAddModal"
            :index="false"
            :loading="loading"
            :data="tableData"
            :show-overflow="false"
            :columns="columns"
            :offset-height="54"
            adapt-parent
            selection
            :pagination="pagination"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">
            <template v-slot:sku="{row}">
              <div>
                <gj-text>{{row.productName | defaultShow}}</gj-text>
              </div>
              <div>{{row.sku | defaultShow}}</div>
              <div>{{row.productType | optionText(ProductEnum.typeOption)}} - {{row.categoryName | defaultShow}}</div>
            </template>
          </gj-table>
        </template>
      </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, queryMixin, selectionMixin} from "@/minxins";
  import {defaultVal, isMeaningful} from "@/utils/common";
  import {getPurchaseOrderAddProductPage} from "@/api/purchase";
  import {ProductEnum} from "@/utils/options";

  export default {
    name: "app-add-product-modal",
    mixins: [modalMixIn, queryMixin, selectionMixin],
    props: {
      deliveryWarehouseId: {
        default: null
      },
      supplierCode: {
        default: null
      },
      hideSkuList: {
        required: true
      },
    },
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'picture', header: '图片', field: 'picture:smallImageUrl', width: '50px'},
          {id: 'sku', header: '产品名称/SKU/产品类型-品类', field: 'slot:sku', minWidth: '200px'},
        ],
        filter: {
          keyword: {
            key: 'sku',
            value: null
          },
          categoryId: null
        },
        option: {
          keyword: [
            {id: 'sku', text: 'SKU'},
            {id: 'name', text: '产品名称'},
          ],
        },
        ProductEnum: ProductEnum,
        matchType: {
          type: 'like'
        },
      }
    },
    methods: {
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            deliveryWarehouseId: this.deliveryWarehouseId,
            supplierCode: this.supplierCode,
            hideSkuList: this.hideSkuList,
            accurateQuery: this.matchType.type !== 'like',
            productSelectType: isMeaningful(this.filter.keyword.value) ? this.filter.keyword.key : null,
            productSelectVal: this.filter.keyword.value,
            productCategoryId: defaultVal(this.filter.categoryId),
          },
          ...this.queryPagination,
          ...this.querySort
        };
        // 查询
        this.loading = true;
        getPurchaseOrderAddProductPage(params)
          .then((data) => {
            this.tableData = data.records;
            this.pagination = this.getPagination(data);
          })
          .complete(() => {
            this.loading = false;
          });
      },
      confirm() {
        if (this.selectedRows.length === 0) {
          this.$gjMessage.error('请勾选产品');
          return;
        }
        this.$emit('select', this.selectedRows);
        this.$gjDestroy();
      }
    }
  }
</script>

<style scoped>

</style>
